<ion-list [formGroup]="parent">
  <ion-radio-group [formControlName]="question.key" [id]="question.key">
    <ion-item *ngFor="let opt of question.options">
      <ion-radio
        [value]="opt.value"
        [attr.disabled]="question.disabled || question.readonly"
      >
        {{ opt.key }}
      </ion-radio>
    </ion-item>
  </ion-radio-group>
</ion-list>
